export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑需求',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
  },
  {
    text: that.$l('menu_text_export') || '导出清单',
    icon: 'el-icon-download',
    menuType: 'export',
    divided: true,
    allow: 'E',
    data: { templateGroup: 'ecom-replenishmentClearance' },
  },
]
